export const notificationListReducer = (state, {type, payload}) => {
    switch (type) {
        case "initNotifications":
            return payload;
        case "addNotification":
            return [...state, ...payload];
        case "readNotitifications":
            
            return state.map( notification => {

                if( payload.includes(notification.id) )
                {
                    return {
                        ...notification,
                        isPending: false
                    }
                }

                return notification
            } )
        default:
            return state;
    }
}
